<div id="duplicate-slots-dialog">
  @if(duplicateType === "single"){
  <form class="form" [formGroup]="form" (ngSubmit)="Submit()">
    <div class="form-content">
      <div class="fieldset">
        <label for="date">{{
          "slot_management.select_date" | translate
        }}</label>
        <p-datepicker
          formControlName="selectedDate"
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="selectedDate"
          [style]="{ width: '100%' }"
          [autofocus]="false"
          [inline]="true"
          [firstDayOfWeek]="1"
          selectOtherMonths="true"
          [minDate]="today"
        />
      </div>
      <div class="buttons">
        <button class="costa-button" [disabled]="!form.valid" type="submit">
          {{ "confirm" | translate }}
        </button>
      </div>
    </div>
  </form>
  }@else if(duplicateType === "multiple"){
  <form class="form" [formGroup]="form" (ngSubmit)="Submit()">
    <div class="form-content">
      <div class="fieldset">
        <label for="date">{{
          "duplicate_slot_dialog.date_range" | translate
        }}</label>
        <p-datepicker
          formControlName="dateRange"
          selectionMode="range"
          [readonlyInput]="true"
          [style]="{ width: '100%' }"
          [autofocus]="false"
          [inline]="true"
          [firstDayOfWeek]="1"
          selectOtherMonths="true"
          [minDate]="today"
        />
      </div>

      <div class="buttons">
        <button class="costa-button" [disabled]="!form.valid" type="submit">
          {{ "confirm" | translate }}
        </button>
      </div>
    </div>
  </form>
  }
</div>
